import React from 'react';
import styles from './style.module.css';

const LoadingBooking = () => {

  return (
    <div className={`card ${styles['booking-card']}`}>
      <div className="">
        <div className="card-body">
            <span className={styles['bookings-loader']}>
                <p className={`card-text placeholder-glow`}>
                  <span className="placeholder col-12 rounded"></span>
                </p>
            </span>
          <div className={styles["card-top-right"]}>
                <p className={`card-text placeholder-glow`}>
                  <span className="placeholder col-12"></span>
                </p>
          </div>

          <div className={styles['booking-durations']}>
            <p className={`card-text placeholder-glow `}>
              <span className="placeholder col-12 rounded"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingBooking;